import Message from "base/Message";
import AjaxForm from "webPage/AjaxForm";

AjaxForm.DEFAULT_SETTINGS = $.extend(true, AjaxForm.DEFAULT_SETTINGS, {
    validatorSettings: {inputOptions: {operator: "the"}},
    createError: (e) => {
        let errorMessage = e ? e.message : "An unknown error occurred";

        return Message.get_inline_message(errorMessage, e ? "An error occurred" : "");
    },
    classes: {
        loading: "admin-btn--loading",
    },
    selectors: {
        button: ":submit:not(.admin-btn--cancel)",
    },
});
